import { render, staticRenderFns } from "./EditorColorPickerButton.vue?vue&type=template&id=d68e7072"
import script from "./EditorColorPickerButton.vue?vue&type=script&lang=js"
export * from "./EditorColorPickerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports